<template>
    <apexo-modal
        :click-to-close="false"
        name="two-factor-setup"
        :title="$t('auth.twoFactorSetup.modal.title')"
        ref="modal"
        @closed="onClosed"
        @open="onOpen"
    >
        <section class="flex flex-col space-y-4">
            <p class="text-gray-600 font-semibold uppercase text-center text-sm">
                {{ $t('auth.twoFactorSetup.modal.activation') }}
            </p>

            <div class="flex w-full h-full items-center justify-center">
                <div v-html="qrCode" />
            </div>

            <p class="text-sm text-gray-800 text-center">
                {{ $t('auth.twoFactorSetup.modal.instructions') }}
            </p>
        </section>

        <template #footer>
            <apexo-button :primary="false" @click="cancel">
                {{ $t('global.general.cancel') }}
            </apexo-button>

            <apexo-button @click="close">
                {{ $t('auth.twoFactorSetup.modal.button') }}
            </apexo-button>
        </template>
    </apexo-modal>
</template>

<script>
    import ApexoButton from '@/components/Elements/ApexoButton.vue';
    import ApexoModal from '@/components/Elements/ApexoModal';

    export default {
        components: {
            ApexoButton,
            ApexoModal,
        },

        data() {
            return {
                qrCode: null,
                recoveryCodes: [],
            };
        },

        methods: {
            onOpen({ qrCode, recoveryCodes } = {}) {
                this.qrCode = qrCode;
                this.recoveryCodes = recoveryCodes;
            },

            onClosed() {
                if (!this.$wait.is('canceling.2fa')) {
                    this.$emit('closed');
                }

                this.$wait.end('canceling.2fa');
            },

            async cancel() {
                this.$wait.start('canceling.2fa');

                await this.$axios.delete('/user/two-factor-authentication');

                this.close();
            },

            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
